const MapOverviewEpi = ({ legends, campaignExists, textKeys }) => {
  return (
    legends?.length > 0 && (
      <div className="parking-legend">
        <ul>
          {legends.map((item, idx) => (
            <li key={idx} className={`parking-legend__item parking-legend__item--${item.productAdvantageStyle}`}>
              <span className="icon">
                {item.useIcon ? (
                  <svg className="svg-icon svg-icon--keypickup">
                    <use xlinkHref={`/dist/svg/symbols.svg#svg-${item.markerIcon}`} />
                  </svg>
                ) : (
                  <span>P</span>
                )}
              </span>
              <span className="text">{item.title}</span>
            </li>
          ))}

          {campaignExists && (
            <li className="parking-legend__item parking-legend__item--campaign">
              <span className="icon">
                <span>P</span>
              </span>
              <span className="text">
                <strong>{textKeys?.legendCampaignTypeText}</strong>
              </span>
            </li>
          )}
        </ul>
      </div>
    )
  )
}

export default MapOverviewEpi
